module.exports = __webpack_public_path__ + "static/media/homeGif3.bad05a16.gif";